import { computed, defineComponent, toRefs } from "@vue/composition-api";
import { useInputValidations } from "@Shared/@Composables/inputs/useInputValidations";
export default defineComponent({
  name: "BaseFieldLayout",
  components: {},
  props: {
    validator: {
      type: Object,
      default: null
    },
    hasFocus: {
      type: Boolean,
      default: false
    },
    sideGrid: {
      type: Boolean,
      default: false
    },
    noUnderline: {
      type: Boolean,
      default: false
    },
    noErrorIcon: {
      type: Boolean,
      default: false
    },
    showRequiredIndicator: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    radio: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const {
      validator
    } = toRefs(props);
    const isRequired = computed(() => {
      var _validator$value;
      return !!((_validator$value = validator.value) != null && _validator$value.required);
    });
    const {
      hasError,
      hasSoftError,
      errorMessage
    } = useInputValidations(validator);
    return {
      hasError,
      hasSoftError,
      errorMessage,
      isRequired
    };
  }
});